import { useQuery } from '@tanstack/react-query'

import { get } from 'utils/http'

export const useCustomerLeadsLimit = (customerId: any) => {
  return useQuery({
    queryKey: ['customer', customerId, 'leads_limit'],
    queryFn: () => get(`/customers/${customerId}/leads_limit?`),
    retry: false,
    refetchOnWindowFocus: false,
  })
}
